import React, { useEffect, useRef, useState, useContext } from "react";
import "./css/ReceivedInputTextBox.css";
import { ReactComponent as VolumeIcon } from "pixelarticons/svg/volume-2.svg";
import { ReactComponent as TranslateIcon } from "pixelarticons/svg/ab-testing.svg";
import { ReactComponent as SeekIcon } from "pixelarticons/svg/search.svg";
import { ReactComponent as CloseIcon } from "pixelarticons/svg/close.svg";
import { ReactComponent as HeartIcon } from "pixelarticons/svg/heart.svg";
import { ReactComponent as ZapIcon } from "pixelarticons/svg/zap.svg";
import CurrentMissionContext from "./CurrentMissionContext";
import { speakWithWhisper } from "./whisper";

const cssClasses = {
  hoverHighlight: "hover-highlight",
  errorHighlight: "error-highlight",
  shownFootnote: "footnote-shown",
};

export const ReceivedInputTextBox = () => {
  const [timestamp, setTimestamp] = useState(Date.now());
  const [updatedText, setUpdatedText] = useState("Welcome to LingoLand 🌻");
  const [highlightedWordIndex, setHighlightedWordIndex] = useState(null);
  const [translation, setTranslation] = useState(null);
  const [isLoadingTranslation, setLoadingTranslation] = useState(false);
  const [showTranslation, setShowTranslation] = useState(false);
  const [advancedTranslation, setAdvancedTranslation] = useState(null);
  const [isLoadingAdvancedTranslation, setLoadingAdvancedTranslation] =
    useState(false);
  const [showAdvancedTranslation, setShowAdvancedTranslation] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const currentMission = useContext(CurrentMissionContext);

  const closeButtonHandler = () => {
    setIsVisible(false);
  };

  const speakerIconRef = useRef(null);
  const translateIconRef = useRef(null);
  const seekIconRef = useRef(null);
  const zapIconRef = useRef(null);

  const [footnotes, setFootnotes] = useState({});
  const [mappedWordsClassnames, setMappedWordsClassnames] = useState({});

  const toggleTranslation = () => {
    if (showTranslation) {
      setTranslation(null);
    }
    setShowTranslation(!showTranslation);
    if (!showTranslation && !translation) {
      translateText(updatedText);
    }
  };

  const translateText = async (text) => {
    setLoadingTranslation(true);

    try {
      const response = await fetch(`https://htmaaland-3c97b27faa21.herokuapp.com/translate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          text: text,
          dest: "en",
        }),
      });
      const data = await response.json();
      setTranslation(data.translated_text);
    } catch (e) {
      console.error("Error translating text: ", e);
    }

    setLoadingTranslation(false);
  };

  const speakWord = (word, index) => {
    setHighlightedWordIndex(index);

    const utterance = new SpeechSynthesisUtterance(word);

    utterance.onend = () => {
      setHighlightedWordIndex(null);
    };

    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(utterance);
  };

  console.log("updatedText", updatedText);

  const words = updatedText.split(" ").map((word, i) => {
    const wordClass =
      i === highlightedWordIndex
        ? "clickable-word highlighted-word"
        : "clickable-word";
    return (
      <React.Fragment key={i}>
        <span
          id={`word-${i}`}
          className={wordClass}
          onClick={() => speakWord(word, i)}
        >
          {word}
        </span>{" "}
      </React.Fragment>
    );
  });

  const advancedTranslateText = async (text) => {
    setLoadingAdvancedTranslation(true);
    try {
      const response = await fetch(`https://htmaaland-3c97b27faa21.herokuapp.com/translate-ai`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          text: text,
          dest: currentMission.Language + "-English",
        }),
      });
      const data = JSON.parse(await response.text());
      setAdvancedTranslation(data);
    } catch (e) {
      console.error("Error translating text: ", e);
    }

    setLoadingAdvancedTranslation(false);
    setMappedWordsClassnames({});
    setFootnotes({});
  };

  useEffect(() => {
    const updateHandler = (newText) => {
      setUpdatedText(newText);
      setIsVisible(true);
    };

    const intervalId = setInterval(() => {
      if (window.gameInstance) {
        window.gameInstance.events.on("update-text", updateHandler);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);

      if (window.gameInstance) {
        window.gameInstance.events.off("update-text", updateHandler);
      }
    };
  }, []);

  useEffect(() => {
    // console.log(" ");
    // console.log("##########RECEIVEDINPUTTEXTBOX##########");

    console.log(updatedText);

    // console.log("ReceivedInput isVisible", isVisible);
    // console.log("UpdatedText", updatedText);

    const advancedTranslateClickHandler = (event) => {
      event.stopPropagation();
      if (!showAdvancedTranslation && !advancedTranslation) {
        advancedTranslateText(updatedText);
      }
      setShowAdvancedTranslation(!showAdvancedTranslation);
    };

    seekIconRef.current?.addEventListener(
      "click",
      advancedTranslateClickHandler
    );

    const translateClickHandler = (event) => {
      event.stopPropagation();
      toggleTranslation();
    };

    translateIconRef.current?.addEventListener("click", translateClickHandler);

    const speechClickHandler = (event) => {
      event.stopPropagation();
      setTimestamp(Date.now());

      const utterance = new SpeechSynthesisUtterance(updatedText);

      let wordIndex = 0;
      utterance.onboundary = (e) => {
        if (e.name === "word") {
          setHighlightedWordIndex((prevIndex) => (prevIndex ?? -1) + 1);
        }
      };

      utterance.onend = () => {
        setHighlightedWordIndex(null);
      };

      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(utterance);
    };

    speakerIconRef.current?.addEventListener("click", speechClickHandler);

    const whisperClickHandler = (event) => {
      event.stopPropagation();
      setTimestamp(Date.now());
      speakWithWhisper(updatedText);
    };

    zapIconRef.current?.addEventListener("click", whisperClickHandler);

    return () => {
      zapIconRef.current?.removeEventListener("click", whisperClickHandler);

      seekIconRef.current?.removeEventListener(
        "click",
        advancedTranslateClickHandler
      );

      translateIconRef.current?.removeEventListener(
        "click",
        translateClickHandler
      );

      speakerIconRef.current?.removeEventListener("click", speechClickHandler);
    };
  }, [
    updatedText,
    setUpdatedText,
    timestamp,
    showTranslation,
    translation,
    showAdvancedTranslation,
    advancedTranslation,
    window.gameInstance.events,
  ]);

  let mappedWords = null;

  if (advancedTranslation) {
    const originalWords =
      advancedTranslation.orig && advancedTranslation.orig.words;
    const translatedWords =
      advancedTranslation.trans && advancedTranslation.trans.words;
    const mappings = advancedTranslation.map;

    console.log(originalWords, translatedWords, mappings);

    if (originalWords && translatedWords && mappings) {
      mappedWords = mappings.map((map, index) => {
        const origItems = map.origIdx.map((i) => originalWords[i]).join(" ");
        const transItems = map.transIdx
          .map((i) => translatedWords[i])
          .join(" ");
        const classname = map.imperfect
          ? "imperfect-mapping"
          : "perfect-mapping";

        const mouseEnter = () => {
          setMappedWordsClassnames((prev) => ({
            ...prev,
            [index]: cssClasses.hoverHighlight,
          }));

          setFootnotes((prev) => ({
            ...prev,
            [map.comment]: cssClasses.shownFootnote,
          }));
        };

        const mouseLeave = () => {
          setMappedWordsClassnames((prev) => ({
            ...prev,
            [index]: "",
          }));

          setFootnotes((prev) => ({
            ...prev,
            [map.comment]: null,
          }));
        };

        return (
          <>
            <span
              className={`advanced ${classname} ${
                mappedWordsClassnames[`${index}`]
              }`}
              onMouseEnter={mouseEnter}
              onMouseLeave={mouseLeave}
              key={index}
            >
              {origItems} {transItems}
            </span>
            <div className={`footnote ${footnotes[map.comment]}`}>
              {map.comment}
            </div>
          </>
        );
      });
    }
  }

  return isVisible ? (
    <div className="helper-tools">
      <div className="interactive-text-box">
        <div onClick={closeButtonHandler} className="icon close-icon">
          <CloseIcon />
        </div>
        {words}
        {showTranslation && (
          <>
            <div className="hr"></div>
            {isLoadingTranslation ? (
              <span>...</span>
            ) : (
              <span className="translated-text">{translation}</span>
            )}
          </>
        )}
        {showAdvancedTranslation && (
          <>
            <div className="hr"></div>
            {isLoadingAdvancedTranslation ? (
              <span>...</span>
            ) : (
              <div className="translated-text">{mappedWords}</div>
            )}
          </>
        )}
        <div className="icons">
          <div ref={speakerIconRef} className="icon speaker-icon">
            <VolumeIcon />
          </div>
          {/* <div ref={zapIconRef} className="icon zap-icon">
            <ZapIcon />
          </div>
          <div
            ref={translateIconRef}
            className={`icon translate-icon ${showTranslation ? "active" : ""}`}
          >
            <TranslateIcon />
          </div>
          <div ref={seekIconRef} className="icon seek-icon">
            <SeekIcon />
          </div> */}
          <div className="icon">
            <HeartIcon />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
